import React, { useState } from 'react'
import {
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    TextField,
    CircularProgress
} from '@mui/material'
import { useNavigate } from 'react-router-dom'
import Departments from '../Departments'
import { toast } from 'react-toastify'
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import { format } from 'date-fns'
import axios from 'axios'
const BookAnAppointMent = () => {
    const initialFormData = {
        patientName: '',
        email: '',
        mobile: '',
        department: '',
        appointMentdate: '',
        mode: '',
        pageUrl: window.location.href
    }
    const [formData, setFormData] = useState(initialFormData)
    const [errors, setErrors] = useState({})
    const [Loading, setLoading] = useState(false)
    const navigate = useNavigate()
    const allDepartments = [...Departments.medical, ...Departments.surgical]

    const handleChange = e => {
        const { name, value } = e.target
        setErrors(prev => ({ ...prev, [name]: value ? '' : prev[name] }))
        setFormData(prev => ({ ...prev, [name]: value }))
    }
    const inputStyle = {
        '& .MuiOutlinedInput-root': {
            '&.Mui-focused fieldset': {
                borderColor: '#00a6a2 !important',
                borderWidth: '2px !important',
                padding: "4px"
            }
        },
        '& .MuiInputLabel-root': {
            '&.Mui-focused': {
                color: '#f28c38 !important'
            }
        },
        '& .MuiInputBase-input::placeholder': {
            color: '#0d7878',
            opacity: 1
        },

    }
    const inputStyle2 = {
        '& .MuiOutlinedInput-root': {
            '&.Mui-focused fieldset': {
                borderColor: 'transparent', 
                borderBottomColor: '#00a6a2', 
                borderWidth: '0 0 1px 0',
            },
            '& fieldset': {
                borderColor: 'transparent',
                borderBottom: '1px solid #ccc',
            },
        },
        '& .MuiInputLabel-root.Mui-focused': {
            color: '#f28c38',
        },
        '& .MuiOutlinedInput-input::placeholder': {
            color: '#0d7878',
            opacity: 1,
        },
    };
    const validateForm = () => {
        const newErrors = {}

        if (!formData.patientName)
            newErrors.patientName = 'Please enter patient name.'

        if (!formData.department)
            newErrors.department = 'Please select a department.'

        if (!formData.mobile) {
            newErrors.mobile = 'Please enter a mobile number.'
        } else if (!/^\d{10}$/.test(formData.mobile)) {
            newErrors.mobile = 'Mobile number should be 10 digits.'
        }

        if (formData.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
            newErrors.email = 'Please enter a valid email address.'
        }

        if (!formData.appointMentdate) {
            newErrors.appointMentdate = 'Please select a date.'
        }

        if (!formData.mode) {
            newErrors.mode = 'Please select a mode.'
        }

        setErrors(newErrors)
        return Object.keys(newErrors).length === 0
    }

   const handleSubmit = async (event) => {
    event.preventDefault();

    const isValid = validateForm();
    if (!isValid) return;

    try {
        setLoading(true);

        const formattedDate = formData.appointMentdate
            ? format(formData.appointMentdate, 'yyyy-MM-dd')
            : '';
        const payload = {
            Subject: 'Lead From MagnAid Website',
            Data: {
                ...formData,
                appointMentdate: formattedDate,
            },
        };
        const response = await axios.post(
            'https://maxaidapi.azurewebsites.net/api/EmailApi',
            payload,
            {
                headers: {
                    'Content-Type': 'application/json',
                },
                params: {
                    code: 'ejJkX3l8qSvgulht0AFLPDySiepq0di50UeRGPa4r5VBAzFudFpISA==',
                },
            }
        );
        const dataMessage = response.data;

        if (dataMessage.status === 'Success') {
            setFormData(initialFormData);
            navigate('/thank-you');
        } else {
            toast.error('Something went wrong', dataMessage.message);
        }
    } catch (error) {
        console.error('Failed to send email:', error.response?.data || error.message);
        toast.error(
            'Failed to send email',
            error.response?.data || error.message,
            { style: { color: 'black' } }
        );
    } finally {
        setLoading(false);
    }
};


    return (
        <div className='flex justify-center items-center w-full mt-6 mb-16'>
            <div className='flex flex-col xl:flex-row 2xl:w-[85%] lg:w-[90%]  pb-8 border border-dashed border-[#c4e5e5] rounded-3xl shadow-lg'>
                <form
                    className='flex xl:flex-row flex-col mt-4 px-4' 
                    onSubmit={handleSubmit}
                >
                    <div className='xl:w-2/12 w-full flex items-center justify-center text-center text-[#0066b3] '>
                        <h2 className='text-3xl text-lightGreen px-4'>
                            Book an Appointment
                        </h2>
                    </div>
                    <div className='xl:w-8/12 w-full'>

                        <div className='flex flex-wrap justify-center xl:gap-x-5 2xl:gap-x-10 md:px-8 lg:px-0'>
                            <div className='md:w-1/2 w-full  xl:w-[30%] 2xl:w-[28%] p-3 lg:mb-2'> 
                                <TextField
                                    fullWidth
                                    label='Full Name'
                                    name='patientName'
                                    disabled={Loading}
                                    value={formData.patientName}
                                    onChange={handleChange}
                                    error={!!errors.patientName}
                                    helperText={errors.patientName}
                                    sx={inputStyle}
                                    variant='standard'
                                />
                            </div>
                            <div className='md:w-1/2 w-full  xl:w-[30%] 2xl:w-[28%] p-3 lg:mb-2'> 
                                <TextField
                                    fullWidth
                                    disabled={Loading}
                                    label='Phone Number'
                                    name='mobile'
                                    type='tel'
                                    value={formData.mobile}
                                    onChange={handleChange}
                                    error={!!errors.mobile}
                                    helperText={errors.mobile}
                                    sx={inputStyle}
                                    variant='standard'
                                />
                            </div>
                            <div className='md:w-1/2 w-full  xl:w-[30%] 2xl:w-[28%] p-3 lg:mb-2'>
                                <TextField
                                    fullWidth
                                    disabled={Loading}
                                    label='Email'
                                    name='email'
                                    type='email'
                                    value={formData.email}
                                    onChange={handleChange}
                                    error={!!errors.email}
                                    helperText={errors.email}
                                    sx={inputStyle}
                                    variant='standard'
                                />
                            </div>
                            <div className='w-full md:w-1/2  xl:w-[30%] 2xl:w-[28%] px-3 mb-2 py-3 mt-2 lg:pt-1'>  {/* Increased padding here */}
                                <FormControl
                                    fullWidth
                                    error={!!errors.department}
                                    variant='outlined'
                                >
                                    <InputLabel id='service-label'>Select Department</InputLabel>
                                    <Select
                                        labelId='service-label'

                                        disabled={Loading}
                                        name='department'
                                        value={formData.department}
                                        onChange={handleChange}
                                        label='Select Service'
                                        sx={inputStyle}
                                        variant='standard'
                                        MenuProps={{
                                            PaperProps: {
                                                style: {
                                                    maxHeight: 300,
                                                    overflowY: 'auto',
                                                    scrollBehavior: 'smooth'
                                                }
                                            }
                                        }}
                                    >
                                        {allDepartments.map(dept => (
                                            <MenuItem key={dept.title} value={dept.title}>
                                                {dept.title}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                    {errors.department && (
                                        <p className='text-[#d32f2f] text-[0.75rem] font-body font-semibold'>
                                            {errors.department}
                                        </p>
                                    )}
                                </FormControl>
                            </div>
                            <div className='w-full md:w-1/2  xl:w-[30%] 2xl:w-[28%] px-3 lg:pt-1 mt-2 py-3'>
                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                    <DemoContainer components={['DatePicker']}>
                                        <DatePicker
                                            disabled={Loading}
                                            value={formData.appointMentdate}
                                            minDate={new Date()}
                                            onChange={(newValue) =>
                                                setFormData(prev => ({ ...prev, appointMentdate: newValue }))
                                            }
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    error={!!errors.appointMentdate}
                                                    helperText={errors.appointMentdate}
                                                    sx={inputStyle2}
                                                    fullWidth
                                                />
                                            )}
                                        />

                                    </DemoContainer>
                                </LocalizationProvider>
                                {errors.appointMentdate && (
                                    <p className='text-[#d32f2f] text-[0.75rem] font-body font-semibold'>
                                        {errors.appointMentdate}
                                    </p>
                                )}
                            </div>
                            <div className='w-full md:w-1/2  xl:w-[30%] 2xl:w-[28%] pb-3 mt-2  ps-3'>
                                <FormControl error={!!errors.mode} disabled={Loading}>
                                    <FormLabel id="demo-row-radio-buttons-group-label">Mode</FormLabel>
                                    <RadioGroup
                                        row
                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                        name="mode"
                                        value={formData.mode}
                                        onChange={handleChange}
                                    >
                                        <FormControlLabel value="online" control={<Radio />} label="Online" />
                                        <FormControlLabel value="in-person" control={<Radio />} label="In-Person" />
                                    </RadioGroup>
                                    {errors.mode && (
                                        <p className='text-[#d32f2f] text-[0.75rem] font-body font-semibold'>
                                            {errors.mode}
                                        </p>
                                    )}
                                </FormControl>

                            </div>
                        </div>

                    </div>
                    <div className='w-full xl:w-2/12 pt-4 px-4 flex text-center justify-center items-center'>
                        <button
                            type='submit'
                            disabled={Loading}
                            className={`bg-orange text-white ${Loading ? 'px-8' : 'px-10'
                                } py-3 rounded-full text-[16px] font-medium transition-all duration-300 hover:bg-lightGreen hover:translate-y-[-3px] ${Loading ? 'opacity-70 cursor-not-allowed' : ''
                                }`}
                        >
                            {Loading ? (
                                <span className='flex items-center gap-2'>
                                    <CircularProgress size={20} sx={{ color: 'white' }} />
                                    Sending...
                                </span>
                            ) : (
                                'Submit'
                            )}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default BookAnAppointMent